export default __webpack_public_path__ + "static/helehrcase1-03ce551abce9364f1caf559b77372408.png";